import * as React from "react";
import * as style from "./postGrid.module.scss";
import Link from "components/Link";
import { GatsbyImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Trans } from "gatsby-plugin-react-i18next";

export const PostCard = ({
  link,
  img,
  type,
  typeSymbol,
  date,
  tag,
  title,
  description,
  alignStart,
}) => {
  return (
    <Link
      to={link}
      className={`
        ${style.PostCard}
        ${img ? style.PostCard___img : style.PostCard___colored}
      `}
    >
      {img && (
        <GatsbyImage image={img} alt={title} className={style.Postcard_img} />
      )}
      <div className={style.Postcard_content}>
        {typeSymbol && typeSymbol === "play" ? (
          <span className={`${style.PostCard_type} ${style.PostCard_playSymbol}`}>{type}</span>
        ) : (
          <span className={style.PostCard_type}>{type}</span>
        )}
        <span
          className={`${style.PostCard_date} ${
            alignStart ? style.PostCard_date___alignStart : ""
          }`.trim()}
        >
          {date}
        </span>
        {tag && <span className={style.PostCard_tag}>{tag}</span>}
        <h1 className={style.PostCard_title}>{title}</h1>
        {description && (
          <p className={style.PostCard_description}>{description}</p>
        )}
      </div>
    </Link>
  );
};

PostCard.propTypes = {
  link: PropTypes.string,
  img: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  type: PropTypes.string,
  typeSymbol: PropTypes.string,
  date: PropTypes.string,
  tag: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  alignStart: PropTypes.bool,
};

PostCard.displayName = "PostCard";

export const NoResultsMessage = ({ text }) => {
  return <div className={style.NoResultsMessage}>
    <Trans 
      i18nKey={text} 
      components={{ Link: <Link /> }}
    />
  </div>;
};

NoResultsMessage.propTypes = {
  text: PropTypes.string,
};

NoResultsMessage.displayName = "NoResultsMessage";

export const GoToHistoryCard = ({ link }) => {
  return (
    <Link to={link} className={style.GoToHistoryCard}>
      <div className={style.GoToHistoryCard_arrow}>
        <ArrowForwardIcon />
      </div>
      <span className={style.GoToHistoryCard_title}>Go to archive</span>
    </Link>
  );
};

GoToHistoryCard.propTypes = {
  link: PropTypes.string,
};

GoToHistoryCard.displayName = "GoToHistoryCard";

const PostGrid = ({ title, TitleTag, postCards }) => {
  return (
    <div className={style.PostGrid}>
      {title && <TitleTag className={style.PostGrid_title}>{title}</TitleTag>}
      {postCards}
    </div>
  );
};

export default PostGrid;

PostGrid.propTypes = {
  title: PropTypes.string,
  TitleTag: PropTypes.string,
  postCards: PropTypes.node,
};

PostGrid.displayName = "PostGrid";
